import { Avatar, Box, Typography } from "@mui/material";
import React from "react";
import moment from "moment";
import Constant from "src/utils/Constant";
import FooterImage from "../../footer-image";
import DescTooltip from "../booking-header/DescTooltip";
import { useTranslation } from "react-i18next";
import { useFacebookPixelPublic } from "src/views/hooks/useFacebookPixelPublic";
import { useGoogleAnalyticsPublic } from "src/views/hooks/useGoogleAnalyticsPublic";

const Success = ({
  selectedSessionTime,
  selectedOffer,
  coachDetails,
  getValues,
}) => {
  const { t } = useTranslation();

  const [rerenderPixel, setRerenderPixel] = React.useState(1);

  const user_settings = coachDetails?.settings
    ? JSON.parse(coachDetails?.settings)
    : null;
  const __analytics = user_settings?.analytics ?? null;
  let enable = __analytics?.has_meta_pixel ?? false;
  let pixelId = __analytics?.meta_pixel ?? null;
  let googleAnalyticsEnable = __analytics?.has_google_analytics ?? false;
  let gaId = __analytics?.google_analytics ?? null;

  const trackEventInFacebook = useFacebookPixelPublic({
    track: "Purchase",
    content_name: `${selectedOffer?.name ?? ""} Purchase completed`,
    content_description: `${
      selectedOffer?.description ?? "Purchase completed."
    }`,
    enable: enable,
    pixelId: pixelId,

    // purchased extra config
    currency: selectedOffer?.custom_options?.currency ?? "USD",
    value: selectedOffer?.price ?? 0,
    content_type: selectedOffer?.category ?? "package",
    packageId: selectedOffer?.id,
  });

  const trackEventInGoogleAnalytics = useGoogleAnalyticsPublic({
    enable: googleAnalyticsEnable,
    gaId: gaId,
  });

  React.useEffect(() => {
    // track purchage on free booking
    if (rerenderPixel) {
      trackEventInFacebook();
      trackEventInGoogleAnalytics("purchase", {
        content_name: `${selectedOffer?.name ?? ""} Purchase completed`,
        content_description: `${
          selectedOffer?.description ?? "Purchase completed."
        }`,
      });
    }
  }, [rerenderPixel]);

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 40px)",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Box>
          <Typography
            sx={{
              fontFamily: "var(--font-grenettepromedium)",
              fontSize: "26px",
              lineHeight: "normal",
              color: "#19181B",
              textAlign: "center",
            }}
          >
            {t("individual.booking.schedule.alert.booking_scheduled")}
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "21px",
              color: "#6E757C",
              mt: "16px",
              textAlign: "center",
            }}
          >
            {t(
              "individual.booking.schedule.alert.booking_scheduled.email_sent"
            )}
          </Typography>
        </Box>

        <Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "40px" }}>
            <Avatar
              // src={Constant.imageUrl("coach", coachDetails?.avatar)}
              src={Constant.getFileInStorage("coach", coachDetails?.avatar)}
              sx={{
                height: "80px",
                width: "80px",
                ...(!coachDetails?.avatar && {
                  backgroundColor: "#7B1FA2",
                }),
              }}
            >
              {coachDetails?.name?.charAt()?.toUpperCase()}
            </Avatar>
          </Box>

          <Box sx={{ mt: "16px" }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "16px",
                color: "#6E757C",
                textAlign: "center",
              }}
            >
              {t(
                "individual.booking.schedule.choose_schedule.you_are_meeting_with"
              )}
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "26px",
                color: "#19181B",
                textAlign: "center",
                textTransform: "capitalize",
              }}
            >
              {coachDetails?.name}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "440px" },
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "12px 24px",
                gap: "20px",
                border: "1px solid #DFDFE1",
                borderRadius: "8px",
                backgroundColor: "#F7F7F7",
                mt: "32px",
              }}
            >
              <Box sx={{ width: "72px" }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "20px",
                    color: "#6F6D77",
                  }}
                >
                  {t("individual.booking.schedule.choose_schedule.package")}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: "7px", alignItems: "center" }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "20px",
                    color: "#222128",
                    textTransform: "capitalize",
                  }}
                >
                  {selectedOffer?.name}
                </Typography>

                <DescTooltip
                  title={selectedOffer?.name}
                  description={selectedOffer?.description}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "440px" },
            }}
          >
            <Box
              sx={{
                border: "1px solid #DFDFE1",
                borderRadius: "8px",
                backgroundColor: "#F7F7F7",
                mt: "16px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "12px 24px",
                  gap: "16px",
                  borderBottom: 1,
                  borderColor: "#DFDFE1",
                }}
              >
                <Box sx={{ width: "72px" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#6F6D77",
                    }}
                  >
                    {t("individual.booking.schedule.choose_schedule.guest")}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#222128",
                      textTransform: "capitalize",
                    }}
                  >
                    {getValues("firstname")} {getValues("lastname")}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "12px 24px",
                  gap: "16px",
                  borderBottom: 1,
                  borderColor: "#DFDFE1",
                }}
              >
                <Box sx={{ width: "72px" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#6F6D77",
                    }}
                  >
                    {t("individual.booking.schedule.choose_schedule.date")}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#222128",
                    }}
                  >
                    {moment(selectedSessionTime?.start).format(
                      "dddd, DD MMM YYYY"
                    )}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "12px 24px",
                  gap: "16px",
                }}
              >
                <Box sx={{ width: "72px" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#6F6D77",
                    }}
                  >
                    {t("individual.booking.schedule.choose_schedule.time")}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "20px",
                      color: "#222128",
                    }}
                  >
                    {moment(selectedSessionTime?.start).format("hh:mm A")} -{" "}
                    {moment(selectedSessionTime?.start)
                      .add(selectedOffer?.duration, "minutes")
                      .format("hh:mm A")}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            mt: "61px",
            width: "100%",
          }}
        >
          <FooterImage />
        </Box>
      </Box>
    </Box>
  );
};

export default Success;
